export * from './delete-feld-unterkategorie-request.interface';
export * from './delete-feld-unterkategorie-response.interface';
export * from './delete-feld-unterkategorie.shapes';
